import type { Hero } from 'types';
import React from 'react';
import { Paragraph, Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';

const HeroText: React.FC<
  Hero & {
    layout?: 'row' | 'column';
  }
> = ({ title, subTitle, description, layout = 'row' }) => {
  const isColumn = layout === 'column';

  return (
    <Wrap
      tagName="header"
      className={[
        '!gap-y-3 lg:!gap-y-6',
        isColumn
          ? 'lg:grid-cols-3 lg:items-start'
          : 'lg:max-w-3xl lg:text-center',
      ].join(' ')}
    >
      {subTitle && (
        <HeadingBody
          title={subTitle}
          level="4"
          tagName="h2"
          className="col-span-full"
        />
      )}
      <HeadingBody
        title={title}
        level="2"
        tagName="h1"
        className={
          isColumn ? 'lg:col-span-2 lg:max-w-md font-semibold' : 'font-semibold'
        }
      />
      {description && (
        <Paragraph
          size="small"
          tagName="article"
          dangerouslySetInnerHTML={{ __html: description }}
          className={isColumn ? 'lg:col-start-3' : ''}
        />
      )}
    </Wrap>
  );
};
export default HeroText;
